import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { NavController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private navCtrl: NavController) {}

  canActivate(): boolean {
    const loginStatusJSON = localStorage.getItem('loginStatusDB');
    const user = JSON.parse(loginStatusJSON);
    if (!user) {
      this.navCtrl.navigateRoot('/home');
      return false;
    }
    return user;
  }
}
